import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Agent, AgentClient, ServiceProvider, ServiceProvidersClient, UserProfile, UserRoleTypes} from "src/app/web-api-client";
import { ConfirmModalComponent } from "../../../modals/confirm-modal/confirm-modal.component";
import { SuccessModalComponent } from "../../../modals/success-modal/success-modal.component";
import { UnSuccessModalComponent } from "../../../modals/failed-modal/failed-modal.component";
import { ServiceProviderCreationComponent } from "./serviceProvider-creation/serviceProvider-creation.component";
import { ServiceProviderEditComponent } from "./serviceProvider-edit/serviceProvider-edit.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateHelper } from "src/app/shared/helpers/date.helper";
import { WtStorageService } from "../../../wt-storage.service";

@Component({
  selector: 'app-serviceProvider',
  templateUrl: './serviceProvider.component.html',
  styleUrls: ['./serviceProvider.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class ServiceProviderComponent implements OnInit {

  public isLoaded: boolean = false;
  selectedObject: ServiceProvider;
  public allObjects: ServiceProvider[];
  // Presuming you have a property for all the objects
  public searchQuery: string = '';
  public filteredObjects: ServiceProvider[] = [];
  public currentUser: UserProfile;

  constructor(private readonly changeDetectionRef:ChangeDetectorRef,private readonly localStore:WtStorageService, private readonly modalService: NgbModal,public client:ServiceProvidersClient){
    this.currentUser = localStore.getuser();
  }

  ngOnInit(): void {

    this.LoadData();

  }



  public filterObjects() {
    if (this.searchQuery) {
      this.filteredObjects = this.allObjects.filter(object =>
        object.serviceProviderName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        object.serviceProviderEIK.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        object.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredObjects = this.allObjects;
    }
  }



  private LoadData() {
    this.isLoaded = false;
    this.client.getList().subscribe((allObjects: ServiceProvider[]) => {

      this.allObjects = allObjects;
      this.filteredObjects = allObjects;
            this.isLoaded = true;
            this.changeDetectionRef.detectChanges();
        });
    }

 public onSelected(object:ServiceProvider){
   if (this.isSelected(object)){
    this.selectedObject = null;
  }
  else{

     this.selectedObject = object;
  }
 }

  public isSelected(object: ServiceProvider):boolean{
    return this.selectedObject == object;
 }

public onCreation():void{
  const modalRef = this.modalService.open(ServiceProviderCreationComponent, {});
  modalRef.componentInstance.onClose.subscribe(r => {
    this.LoadData();
  });
}


public onDelete(): void {

    let modalRef = this.modalService.open(ConfirmModalComponent);

    modalRef.componentInstance.onClose.subscribe(result => {
      if (result === true) {

        this.client.remove(this.selectedObject.idServiceProvider).subscribe(r => {
          this.modalService.open(SuccessModalComponent);
        })
      }
      else {
        this.modalService.open(UnSuccessModalComponent);
      }
    });


  }

  public onEdit(): void {

    let modalRef = this.modalService.open(ServiceProviderEditComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      windowClass: 'modal-xxl'
    });
    modalRef.componentInstance.editObject = this.selectedObject;
    modalRef.componentInstance.onClose.subscribe(r => {
      this.LoadData();
    })

  }

  public getDate(item:Date):string{
    return DateHelper.GetFormattedDate(item);
  }

  public canSee(): boolean {

    return this.currentUser.userRole != UserRoleTypes.User
  }

}
